<template>
  <div class="nav">
    <img src="../../assets/images/logo.png" @click="goHome()" />
    <ul>
      <li v-for="(item,index) in menuList" :key="index" @click="getLink(index)" :class="{current:currentIndex == index}">{{item}}</li>
    </ul>
    <div class="login-operate" v-if="flag">
      <img src="../../assets/images/user_icon.png" alt="">
      <em @click="login()">登录</em>
      <!-- &nbsp;|<em @click="register()">注册</em> -->
    </div>
    <div class="login-operate logined" @click="modalFlag=!modalFlag" v-else>
      <img :src="avatar" alt="">
      <div class="login-modal" v-show="modalFlag">
        <em @click="loginOut()">退出</em>
        <em @click="personal()">个人中心</em>
      </div>
    </div>
  </div>
</template>

<script>
import { getBasicInfo } from '../../request/api';
export default {
  name: '',
  props:{
    index:{//判断导航栏目
      type:Number,
      default:0
    },
  },
  data () {
    return {
      menuList:[
        '首页',
        '农业知识库',
        '种植经验共享',
        '专家库',
        '知识问答',
        '知识地图',
      ],
      currentIndex:this.index,
      flag:true,
      avatar:null,
      knowledgeId:0,
      experienceId:0,
      modalFlag:false
    }
  },
  created(){
    let getToken = localStorage.getItem("token");// 获取登录token
    if(getToken){// 判断登录
      this.flag = !this.flag;
      getBasicInfo().then(res => {
        if(res.code == 0){
          if(res.data.avatar){
            this.avatar = this.imgUrl+res.data.avatar;
          }else{
            this.avatar = require('../../assets/images/user_icon.png');
          }
          sessionStorage.setItem('type',res.data.type);
          sessionStorage.setItem('expertId',res.data.id);
        }else{
          alert(res.msg);
        }
      }).catch(error => {
        console.log(error);
      });
    }
  },
  methods:{
    goHome(){
      if(this.currentIndex!=0){
        this.$router.push({ name: "home" });
      }
    },
    getLink(index){
      this.currentIndex = index;
      let kid = sessionStorage.getItem("knowledgeId");
      let eid = sessionStorage.getItem("experienceId");
      if(kid){
        this.knowledgeId = kid;
      }
      if(eid){
        this.experienceId = eid;
      }
      if (index == 0) {
        this.$router.push({ name: "home" });
      } else if (index == 1) {
        this.$router.push({ path:"/knowledge-list/"+this.knowledgeId });
      } else if (index == 2) {
        this.$router.push({ path:"/experience-list/"+this.experienceId });
      } else if (index == 3) {
        this.$router.push({ path:"/expert-list/0" });
      } else if (index == 4) {
        this.$router.push({ name: "question-list" });
      } else if (index == 5) {
        this.$router.push({ name: "knowledge-map" });
      }
    },
    login(){
      this.$router.push({name:"login"})
    },
    // register(){
    //   this.$router.push({name:"login"})
    // },
    loginOut(){
      localStorage.setItem('token','');
      this.flag = !this.flag;
    },
    personal(){
      this.$router.push({path:"/system-info"})
    }
  }
}
</script>
<style scoped>
  .nav{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 1330px;
    margin: 0 auto;
    height: 90px;
  }
  .nav ul{
    display: flex;
    color: #000;
    font-size: 20px;
  }
  .nav ul li{
    padding: 20px;
    cursor: pointer;
  }
  .nav ul li.current{
    position: relative;
    color: #0084ff;
  }
  .nav ul li.current:after{
    content: "";
    position: absolute;
    width: 100%;
    height: 4px;
    background: #0084ff;
    bottom: -10px;
    left: 0;
  }
  .login-operate{
    display: flex;
    align-items: center;
    color: #000;
    font-size: 20px;
    cursor: pointer;
  }
  .logined > img{
    width: 46px;
    height: 46px;
    border-radius: 50%;
    display: block;
    margin-right: 5px;
  }
  .login-operate > em{
    color: #0084ff;
    margin-left: 5px;
  }
  .logined{
    position: relative;
    padding-right: 15px;
  }
  .logined:after{
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 8px solid #333;
    right: 0;
    top: 50%;
    margin-top: -4px;
  }
  .login-modal{
    position: absolute;
    right: 0;
    width: 100px;
    font-size: 15px;
    top: 68px;
    z-index: 999;
    background: #fff;
    border: 1px solid #ddd;
    border-top: 0;
  }
  .login-modal > em{
    display: block;
    padding: 10px 15px;
  }
  .login-modal > em:hover{
    color: #0084ff;
  }
</style>


// WEBPACK FOOTER //
// src/components/header/header.vue